import { KendoBaseComponent, KendoBaseInputComponent } from '@progress/kendo-base-components-vue-wrapper'
import DateInputProps from './DateInputProps'

import Messages from './Messages'

export default {
    props: DateInputProps,
    mixins: [
        KendoBaseComponent,
        KendoBaseInputComponent,
        Messages
    ],
    mounted() {
        var that = this
        kendo.jQuery(that.$el).kendoDateInput(that.widgetOptions)

        that.$emit('kendowidgetready', that.kendoWidget())

        that.kendoWidget().bind('change', function () {
            that.$emit('changemodel', that.$refs.valueInput.value)
        })
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoDateInput()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoDateInput/KendoDateInputMixin.js